<template>
  <Box>
    <template #handle>
      <Btn
        @click="addNewDevice"
        v-if="hasPermi('system:dzc:insertDzc')"
        type="blue"
        >新增协议</Btn
      >
      <Btn
              @click="deleteDzc"
              type="blue">删除协议</Btn>
    </template>
    <template #content>
      <div class="table_main">
        <div class="query">
          <div class="left">
            <el-form ref="query_form" :model="queryParams" label-width="80px">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="生产厂家" prop="cjname">
                    <el-input
                      size="small"
                      v-model="queryParams.cjname"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="设备型号" prop="xhname">
                    <el-input
                      size="small"
                      v-model="queryParams.xhname"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="right">
            <Btn @click="query" round>
              <span class="btn_box">
                <i class="iconfont icon-sousuo"></i>
                <span>搜索</span>
              </span>
            </Btn>
            <Btn @click="initQuery" round>
              <span class="btn_box">
                <i class="iconfont icon-chongzhi"></i>
                <span>重置</span>
              </span>
            </Btn>
          </div>
        </div>
        <div class="content">
          <Table :datas="tableData" :heads="tableHead" :selection="true" :loading="loading"  @change="changeTableSelected">
            <template #handle="data">
              <div class="table_cell">
                <span v-if="data.head.handle == 'index'">{{
                  (pageData.page - 1) * pageData.pageSize + data.index
                }}</span>
                <span v-if="data.head.handle == 'status'" :class="['pre']">
                  <span
                    class="_pre"
                    :style="{
                      background: (
                        sbstate.find((a) => a.value == data.data.sbstate) || {}
                      ).color,
                    }"
                  ></span>
                  <span>{{
                    sbstate.find((a) => a.value == data.data.sbstate).label
                  }}</span>
                </span>
                <div v-if="data.head.handle == 'btns'">
                  <Btn
                    type="text"
                    v-if="hasPermi('system:dzc:queryDzcByid')"
                    @click="handleItem(data.data, '协议详情')"
                    >协议详情</Btn
                  >
                  <Btn
                    type="text"
                    v-if="hasPermi('system:dzc:updateDzcById')"
                    @click="handleItem(data.data, '协议修改')"
                  >
                    协议修改</Btn
                  >
                </div>
              </div>
            </template>
          </Table>
          <el-pagination
            class="page"
            background
            layout="total, sizes, prev, pager, next"
            :total="pageData.total"
            :page-sizes = "[10, 20, 50, 100]"
            :current-page.sync="pageData.page"
            :page-size.sync="pageData.pageSize"
            @size-change="query"
            @current-change="getList"
          >
          </el-pagination>
        </div>
      </div>
      <Drawer :open="open" @changeOpen="changeOpen">
        <template #content>
          <el-form
            :model="addForm"
            label-width="130px"
            ref="addForm"
            :rules="rules"
            :class="[
              'demo-ruleForm',
              'formBox',
              disabledTitles.includes(drawerTitle) ? 'disabled' : '',
            ]"
            :disabled="disabledTitles.includes(drawerTitle)"
          >
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="设备型号：" prop="xhname">
                  <el-input size="small" v-model="addForm.xhname"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="生产厂家：" prop="cjname">
                  <el-input
                    size="small"
                    v-model.trim="addForm.cjname"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="帧长度：" prop="frame_len">
                  <el-input-number
                    size="small"
                    v-model.number="addForm.frame_len"
                    controls-position="right"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="结束标识起始位：" prop="end_tag_idx">
                  <el-input-number
                    size="small"
                    v-model.number="addForm.end_tag_idx"
                    controls-position="right"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="开始标识：" prop="start_tag">
                  <el-input
                    size="small"
                    v-model.trim="addForm.start_tag"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="结束标识：" prop="end_tag">
                  <el-input
                    size="small"
                    v-model.trim="addForm.end_tag"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="百位数位置：" prop="h_bit">
                  <el-input-number
                    size="small"
                    v-model.number="addForm.h_bit"
                    controls-position="right"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="十位数位置：" prop="t_bit">
                  <el-input-number
                    size="small"
                    v-model.number="addForm.t_bit"
                    controls-position="right"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="个位数位置：" prop="s_bit">
                  <el-input-number
                    size="small"
                    v-model.number="addForm.s_bit"
                    controls-position="right"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="十分位位置：" prop="decile_bit">
                  <el-input-number
                    size="small"
                    v-model.number="addForm.decile_bit"
                    controls-position="right"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
        <template #footer v-if="!disabledTitles.includes(drawerTitle)">
          <Btn type="blue" @click="commitData">提交</Btn>
          <Btn @click="closeDrawer">取消</Btn>
        </template>
      </Drawer>
    </template>
  </Box>
</template>

<script>
import drawerMixins from "@/components/drawer/drawer";
import {
  dzcList,
  queryDzcByid,
  updateDzcById,
  insertDzc,
  updateDeleteDzc,
} from "@/api/DeviceRunManagement";
import rules, { bt } from "@/utils/formRules";
import permMixin from "@/mixins/perm";
export default {
  mixins: [drawerMixins, permMixin],
  data() {
    return {
      xhname: [],
      queryParams: {
        cjname: "",
        xhname: "",
      },
      rules: {
        xhname: rules.nnc,
        cjname: [bt],
        start_tag: rules.str_16,
        end_tag: rules.str_16,
      },
      tableHead: [
        {
          prop: "xh",
          label: "序号",
          handle: "index",
          width: 50,
          textAlign: "center",
        },
        {
          prop: "xhname",
          label: "设备型号",
        },
        {
          prop: "cjname",
          label: "生产厂家",
        },
        {
          prop: "createUser",
          label: "操作人",
        },
        {
          prop: "createTime",
          label: "添加时间",
        },
        {
          prop: "cz",
          label: "操作",
          handle: "btns",
          textAlign: "left",
          width: 160,
          fixed: "right",
        },
      ],
      tableData: [],
      loading: false,
      pageData: {
        page: 1,
        total: 0,
        pageSize: 10,
      },
      tableSelected:[],
      addForm: {
        xhname: "",
        cjname: "",
        frame_len: "",
        start_tag: "",
        end_tag: "",
        end_tag_idx: "",
        h_bit: "",
        t_bit: "",
        s_bit: "",
        decile_bit: "",
      },
      initAddForm: {
        xhname: "",
        cjname: "",
        frame_len: "",
        start_tag: "",
        end_tag: "",
        end_tag_idx: "",
        h_bit: "",
        t_bit: "",
        s_bit: "",
        decile_bit: "",
      },
      drawerTitle: "",
      disabledTitles: ["协议详情"],
    };
  },
  methods: {
    initQuery() {
      this.pageData.page = 1;
      this.$refs.query_form.resetFields();
    },
    query() {
      this.pageData.page = 1;
      this.getList();
    },
    activeClose() {
      this.activeDialog = false;
      this.activeDialogValue = "";
    },
    activeOpen() {
      this.activeDialog = true;
    },
    activeCommit() {
      const params = {
        id: this.jbh,
      };
    },
    addNewDevice() {
      this.drawerTitle = "新增协议";
      this.addForm = {
        ...this.initAddForm,
      };
      this.changeOpen();
    },
     changeTableSelected(arr = []) {
         this.tableSelected = arr.map(value => value.id);
     },
    async handleItem(data, drawerTitle) {
      this.drawerTitle = drawerTitle;
      this.addForm = {
        ...this.initAddForm,
      };
      await queryDzcByid(data.id).then((res) => {
        res.data.pz = res.data.pz ? JSON.parse(res.data.pz) : {};
        this.addForm = {
          ...this.addForm,
          ...res.data.pz,
          id: data.id,
        };
      });
      this.changeOpen();
    },
    commitData() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return false;
        if (this.drawerTitle == "协议修改") {
          const params = {};
          params.id = this.addForm.id;
          const _params = Object.assign({}, this.addForm);
          delete _params.id;
          params.pz = JSON.stringify(_params);
          params.xhname = _params.xhname;
          params.cjname = _params.cjname;
          updateDzcById(params).then(() => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.addForm = {
              ...this.initAddForm,
            };
            this.changeOpen();
            this.getList();
          });
        } else {
          const params = {};
          const _params = Object.assign({}, this.addForm);
          params.pz = JSON.stringify(_params);
          params.xhname = _params.xhname;
          params.cjname = _params.cjname;
          insertDzc(params).then((res) => {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.addForm = {
              ...this.initAddForm,
            };
            this.changeOpen();
            this.getList();
          });
        }
      });
    },
    getList() {
      this.loading = true
      const params = {
        ...this.queryParams,
        currentPage: this.pageData.page,
        pageSize: this.pageData.pageSize
      };
      dzcList(params)
        .then((res) => {
          this.pageData.total = res.data?.count || 0;
          res.data.list?.forEach((item) => {
            item.createTime = item.createTime?.substr(0, 10) || "";
          });
          this.tableData = res.data?.list || [];
          this.loading = false
        })
        .catch(() => {
          this.pageData.total = 0;
          this.tableData = [];
          this.loading = false
        });
    },
    deleteDzc(){
       if( this.tableSelected.length<1){
           this.$message.error("请至少选择一条数据");
           return;
       }
        this.$confirm("是否删除选中的设备？","提示",{
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        })
         .then(() => {
             updateDeleteDzc(this.tableSelected).then((res) => {
                 this.$message.success(res.msg);
                 this.getList();
             });
         })
         .catch(() => { })
    },
  },
  created() {
    this.getList();
  },
};

// public class EW_PacketInfo
//     {    设备名称
//         public string Name { get; set; }
//          型号 自己起
//         /// <summary>
//         /// 报文帧长度
//         /// </summary>
//         public int frame_len { get; set; }

//         /// <summary>
//         /// 开始标识
//         /// </summary>
//         public string start_tag { get; set; }
//         /// <summary>
//         /// 结束标识
//         /// </summary>
//         public string end_tag { get; set; }
//         /// <summary>
//         /// 结束标识起始位
//         /// </summary>
//         public int end_tag_idx { get; set; }
//         /// <summary>
//         /// 结果数据百位位置
//         /// </summary>
//         public int h_bit { get; set; }
//         /// <summary>
//         /// 结果数据十位位置
//         /// </summary>
//         public int t_bit { get; set; }
//         /// <summary>
//         /// 结果数据个位位置
//         /// </summary>
//         public int s_bit { get; set; }
//         /// <summary>
//         /// 结果数据十分位位置
//         /// </summary>
//         public int decile_bit { get; set; }
//     }

//     frame_len：取值0-N，全数字

//     start_tag 必须是双数，符合16进制数

//     end_tag的规则同start

//     end_tag_idx < frame_len-1

//  h_bit, t_bit, s_bit, decile_bit 必须>0 且 < frame_len-1
</script>

<style></style>
